import React, { useEffect } from "react";
import pickup_location from "../../../../assets/pickup_location.svg";
import desti_location from "../../../../assets/desti_location.svg";
import pickup_time from "../../../../assets/pickup_time.svg";
import { Row, InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useState } from "react";
import "./ExplorecabPage.css";
import { connect } from "react-redux";
import {
  maintainPickup,
  maintainVehiclelist,
  maintainWaytype,
} from "../../../home/redux/actions";
import { maintainDestination } from "../../../home/redux/actions";
import { maintainPickupdatetime } from "../../../home/redux/actions";
import { maintainReturndatetime } from "../../../home/redux/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { maintainModify } from "../../../home/redux/actions";
import { getRequestcall } from "../../../comman/util/getRequest";
import {
  AIRPORT_LIST,
  GET_DISTANCE,
} from "../../../constants/apiurl";
import { maintainAirportlist } from "../../../header/redux/actions";
import ButtonPage from "../../../comman/button/ButtonPage";
import CapAutocompletePlace from "../../../comman/components/CapAutocompletePlace";
import { toast } from "react-toastify";
import moment from "moment";
import PropTypes from "prop-types";

function ExplorecabPage(props) {

  const { t } = useTranslation();

  const waytype = [
    {
      id: 1,
      type: t("pages.ONE WAY"),
      className: "oneway"
    },
    {
      id: 2,
      type: t("pages.ROUND TRIP"),
      className: "roundtrip"
    },
    {
      id: 3,
      type: t("pages.AIRPORT"),
      className: "airport"
    },
  ];

  let buttonStyle = {
    color: "white",
    background: "#FF091B",
    borderRadius: "21px",
  };
  const [startDate, setStartdate] = useState();
  const [returnDate, setReturndate] = useState();
  const [pickuplocation, setPickuplocation] = useState("");
  const [pickuplocationplace, setPickuplocationplace] = useState("");
  const [destinationlocation, setDestinationlocation] = useState("");
  const [destinationlocationplace, setDestinationlocationplace] = useState("");

  const navigate = useNavigate();
  const [error, setError] = useState({
    pickup: "",
    destination: "",
    returnDate: "",
    pickupTime: ""
  });

  const [showairports, setShowairports] = useState(false);
  const [dropairports, setDropairports] = useState(false);

  let time_min = new Date();
  time_min.setHours(12)
  time_min.setMinutes(0)
  var [mintime] = useState(time_min)

  let time_max = new Date();
  time_max.setHours(11)
  time_max.setMinutes(30)
  var [maxtime] = useState(time_max)

  // eslint-disable-next-line
  useEffect(() => {
    (async () => maintainInformation())();
    // eslint-disable-next-line
  }, [props?.language]);

  const maintainInformation = () => {
    if (
      props?.showmodify === false ||
      typeof props?.showmodify === "undefined"
    ) {
      props?.maintainWaytype(waytype[0]);
      let pickupDate = moment(new Date()).format("YYYY-MM-DD HH:mm")
      props?.maintainPickupdatetime(pickupDate);
      props?.maintainReturndatetime("");
    } else {
      // If modifypopup true then show
      showModifyCondition();
    }
  };

  const showModifyCondition = () => {
    let gettype = waytype.filter((item) => item.id === props?.waytype?.id);
    props?.maintainWaytype(gettype[0]);
    setPickuplocationplace(props?.pickup?.from_place);
    setDestinationlocationplace(props?.destination?.to_place);
    setStartdate(new Date(Date.parse(props?.pickupdate_time)));
    if (gettype[0]?.id === 2) {
      setReturndate(new Date(Date.parse(props?.returndate_time)));
    }
  }
  const getAireportlisting = async () => {
    // let CountryList = `?country=${props?.currentLocation?.country}`;
    // if(props?.currentLocation?.country === ""){
    //   CountryList = `?country=${props?.currentLocation?.state}`
    // }
    // if(props?.currentLocation?.country === "India"){
    //   CountryList = `?country=${props?.currentLocation?.state}`;
    //   if(props?.currentLocation?.country === ""){
    //     CountryList = `?country=${props?.currentLocation?.state}`
    //   }
    // }
    const CountryList = `?lat=${props?.currentLocation?.lat}&lng=${props?.currentLocation?.lng}`

    let geturl = AIRPORT_LIST + CountryList;
    let getListing = await getRequestcall(geturl, "");
    if (getListing?.status === 200) {
      let list = await getListing.json();
      let airport = {};
      let airportList = [];
      list.results.forEach((item) => {
        airport = {
          name: item.name,
          lat: item.geometry.location.lat,
          lng: item.geometry.location.lng,
        };
        airportList.push(airport);
      });
      props.maintainAirportlist(airportList);
    }
  }

  const selectPickuplocation =async ({ place, address, Lat, lng, ZipCode }) => {
    setPickuplocation("");
    setPickuplocationplace(address);
    let pickup = {
      from_place: address,
      from_place_lat: Lat.toString(),
      from_place_lng: lng.toString(),
    };
    props.maintainPickup(pickup);
    if(destinationlocationplace){
      await getDistance(props?.destination?.to_place_lat, props?.destination?.to_place_lng, address, destinationlocationplace);
    }
  }

  const selectDestinationlocation = async ({ place, address, Lat, lng, ZipCode }) => {
    setDestinationlocation("");
    setDestinationlocationplace(address);
    await getDistance(Lat, lng, pickuplocationplace, address);
  };

  const getDistance = async (lat, lng, Origin, value) => {
    if(Origin && value){
        let geturl =
        GET_DISTANCE +
        `?origin=${Origin
          .split(" ")
          .join("")}&destination=${value.split(" ").join("")}`;
      let getDistanceResponse = await getRequestcall(geturl, "");
      if (getDistanceResponse?.status === 200) {
        let distance = await getDistanceResponse.json();
        if(distance?.rows[0]?.elements[0]?.distance?.value){
          let kilometer = (distance?.rows[0]?.elements[0]?.distance?.value / 1000).toFixed(2);
          if(props?.waytype?.id === 2){
            kilometer = kilometer * 2 
          }
          let destination = {
            to_place: value,
            to_place_lat: lat.toString(),
            to_place_lng: lng.toString(),
            kilometer: kilometer,
          };
          console.log("kilometer",distance?.rows[0]?.elements[0]?.distance);
          props.maintainDestination(destination);
          setError({
            ...error,
            destination: "",
          });
        }else{
          toast.info(t('pages.Sorry, the selected address is not reachable. Please make sure to select appropriate address'))
          let destination = {
            to_place: value,
            to_place_lat: lat.toString(),
            to_place_lng: lng.toString(),
            kilometer: 0,
          };
          props.maintainDestination(destination);
        }
      } 
    }else if(value){
      let destination = {
        to_place: value,
        to_place_lat: lat.toString(),
        to_place_lng: lng.toString(),
        kilometer: 0,
      };
      props.maintainDestination(destination);
    }
  };

  const selectPickuplocationairport =async (e, item) => {
    e.preventDefault();
    setShowairports(false);
    setPickuplocation("");
    setPickuplocationplace(item.name);
    let pickup = {
      from_place: item.name,
      from_place_lat: item.lat.toString(),
      from_place_lng: item.lng.toString(),
    };
    props.maintainPickup(pickup);
    if(props?.destination?.to_place){
      await getDistance(props?.destination?.to_place_lat, props?.destination?.to_place_lng, item.name, props?.destination?.to_place);
    }
    setError({
      ...error,
      pickup: "",
    });
  };

  const selectDroplocationairport =async (e, item) => {
    e.preventDefault();
    setDropairports(false);
    setDestinationlocation("");
    setDestinationlocationplace(item.name);
    await getDistance(item.lat.toString(), item.lng.toString(), props?.pickup?.from_place, item.name);
    // let destination = {
    //   to_place: item.name,
    //   to_place_lat: item.lat.toString(),
    //   to_place_lng: item.lng.toString(),
    // };
    // props.maintainDestination(destination);
    setError({
      ...error,
      destination: "",
    });
  };

  const pickupValueChange = (value) => {
    setShowairports(false);
    setPickuplocation(value);
    setError({
      ...error,
      pickup: "",
    });
  };

  const destinationValueChange = (value) => {
    setDropairports(false);
    setDestinationlocation(value);
    setError({
      ...error,
      destination: "",
    });
  };

  const dateTimechange = (date) => {
    let pickupDate = moment(date).format("YYYY-MM-DD HH:mm");
    // console.log("pickupDate", pickupDate)
    props.maintainPickupdatetime(pickupDate);
    setStartdate(date);
    if(!returnDate){
      setReturndate(date);
    }
    let return_Date = moment(date).format("YYYY-MM-DD HH:mm");
    props.maintainReturndatetime(return_Date);
    setError({
      ...error,
      pickupTime: ""
    })
  };

  const returnDatechange = (date) => {
    let returnDate = moment(date).format("YYYY-MM-DD HH:mm");
    props.maintainReturndatetime(returnDate);
    setReturndate(date);
    setError({
      ...error,
      returnDate: ""
    });
  };

  const selectType = (item) => {
    props.maintainWaytype(item);
    setShowairports(false);
    setDropairports(false);
    clearPlaces(item);
    if (item.id === 3) {
      getAireportlisting();
    }
  };

  const clearPlaces = (item) => {
    // return date and time only for round trip
    if (item.id === 1 || item.id === 3) {
      props?.maintainReturndatetime("");
    }
    // If type is aireport clear the location place
    // if (item?.id === 3) {
      clearLocationplace();
    // }
  };

  const clearLocationplace = () => {
    let pickup = {
      from_place: "",
      from_place_lat: "",
      from_place_lng: "",
    };
    props.maintainPickup(pickup);
    let destination = {
      to_place: "",
      to_place_lat: "",
      to_place_lng: "",
      kilometer: 0,
    };
    props.maintainDestination(destination);
    setPickuplocationplace("");
    setDestinationlocationplace("");
  };

  const openSourcelist = () => {
    setDropairports(false);
    filterListing(
      props?.destination?.to_place_lat,
      props?.destination?.to_place_lng
    );
    if (props?.waytype?.id === 3) {
      if (pickuplocation === "") {
        setShowairports(true);
      }
    } else {
      setShowairports(false);
    }
  };

  const openDestinationlist = () => {
    setShowairports(false);
    filterListing(props?.pickup?.from_place_lat, props?.pickup?.from_place_lng);
    if (props?.waytype?.id === 3) {
      if (destinationlocation === "") {
        setDropairports(true);
      }
    } else {
      setDropairports(false);
    }
  };

  // Filter the air port listing
  const filterListing = (lat, lng) => {
    let getlist = props?.airport_list?.filter(
      (item) =>
        item.lat.toString() !== lat?.toString() &&
        item.lng.toString() !== lng?.toString()
    );
    props.maintainAirportlist(getlist);
  };

  const validation = () => {
    let value = true;
    if (pickuplocationplace === "") {
      error.pickup = "pages.Enter your pickup location";
      value = false;
    }
    if (destinationlocationplace === "") {
      error.destination = "pages.Enter your destination location";
      value = false;
    }
    if (!props?.destination?.kilometer || props?.destination?.kilometer <=0 ) {
      error.destination = "pages.Enter your correct destination location";
      value = false;
    }
    // validation cases for one way 
    let getTime = oneWaytripCase();
    if (getTime !== "") {
      error.pickupTime = getTime;
      value = false;
    } else {
      error.pickupTime = "";
    }

    // validation cases for round trip     
    if (props?.waytype?.id === 2) {
      let getValue = roundTripCase();
      if (getValue !== "") {
        error.returnDate = getValue;
        value = false;
      } else {
        error.returnDate = "";
      }
    } else {
      error.returnDate = "";
    }

    setError({
      ...error,
      pickup: error.pickup,
      destination: error.destination,
      returnDate: error.returnDate,
      pickupTime: error.pickupTime
    });

    return value;
  };

  const oneWaytripCase = () => {
    let getTime = "";
    let currentTime = new Date().getTime();
    let pickupTime = new Date(typeof startDate === "undefined" ? new Date() : startDate).getTime();
    if (typeof startDate === "undefined") { 
      setStartdate(new Date());
      let pickupDate = moment(new Date()).format("YYYY-MM-DD HH:mm");
      props?.maintainPickupdatetime(pickupDate);
    }
    if (pickupTime < currentTime) {
      getTime = "pages.Select valid pickup time";
      // console.log("pickupValue > returnValue",startDate, new Date())

    } else if (currentTime > pickupTime) {
      getTime = "";
    }
    return getTime;
  }

  const roundTripCase = () => {
    let getDate;
    let pickupValue = new Date(typeof startDate === "undefined" ? new Date() : startDate).getTime();
    let returnValue = new Date(typeof returnDate === "undefined" ? new Date() : returnDate).getTime();
    if (typeof startDate === "undefined") { 
      setStartdate(new Date());
      let pickupDate = moment(new Date()).format("YYYY-MM-DD HH:mm");
      props?.maintainPickupdatetime(pickupDate);
    }
    if (typeof returnDate === "undefined") { 
      setReturndate(new Date());
      let returnDate = moment(new Date()).format("YYYY-MM-DD HH:mm")
      props?.maintainReturndatetime(returnDate);
    }
    if (pickupValue < returnValue) {
      getDate = "";
    } else if (pickupValue > returnValue) {
      getDate = "pages.Please select valid return time";
    } else {
      getDate = "pages.Please select valid return time"
    }
    return getDate;
  }

  const exploreCab = async (e) => {
    e.preventDefault();
    var ifConnected = window.navigator.onLine;
    if (ifConnected) {
      if (validation()) {
        props?.callBackList();
        props?.maintainModify(false);
        navigate("/cabs");
      }
    } else {
      toast.error(t("pages.Internet connection not available"));
    }
  };

  return (
    <>
      <div className="mb-3 cab-heading">
        <h5 className="cab-booking m-0">
          {t("pages.Cab Booking")}
        </h5>
        <div className="vehicle-type">
          <ul>
            {waytype.map((item, index) => (
              <React.Fragment key={index?.toString()}>
                <li
                  onClick={() => selectType(item)}
                  style={{
                    borderRight: index === waytype.length - 1 ? "none" : "",
                  }}
                >
                  <button
                    className={item.className}
                    style={item.id === props?.waytype?.id ? buttonStyle : {}}
                  >
                    {item.type}
                  </button>
                </li>
              </React.Fragment>
            ))}
          </ul>
        </div>
        <h5 className="cab-booking-mob">
          {t("pages.Cab Booking")}
        </h5>
      </div>
      <div className="explore-cab">
        <Row>
          <div
            className={
              props?.waytype?.id === 1 || props?.waytype?.id === 3
                ? "col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-5 locatin-input"
                : "col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-5 locatin-input"
            }
          >
            <CapAutocompletePlace
              setAddress={pickupValueChange}
              address={pickuplocation}
              placaddress={pickuplocationplace === "" ? t("pages.myrides.pickup_location") : pickuplocationplace}
              SetLocation={selectPickuplocation}
              className={"user-location"}
              formTaxt={pickup_location}
              searchOptions={{
                country: props?.currentLocation?.isocode?.toLowerCase(),
              }}
              showairports={showairports}
              selectPickuplocationairport={selectPickuplocationairport}
              airport_list={props?.airport_list}
              onClick={openSourcelist}
            />
            <span className="text-white" style={{ display: error.pickup === "" ? "none" : "" }}>{t(error.pickup)}</span>
          </div>
          <div
            className={
              props?.waytype?.id === 1 || props?.waytype?.id === 3
                ? "col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-5 locatin-input"
                : "col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-5 locatin-input"
            }
          >
            <CapAutocompletePlace
              setAddress={destinationValueChange}
              address={destinationlocation}
              placaddress={destinationlocationplace === "" ? t("pages.myrides.destination_location") : destinationlocationplace}
              SetLocation={selectDestinationlocation}
              className={"user-location"}
              formTaxt={desti_location}
              searchOptions={{
                country: props?.currentLocation?.isocode?.toLowerCase(),
              }}
              showairports={dropairports}
              selectPickuplocationairport={selectDroplocationairport}
              airport_list={props?.airport_list}
              onClick={openDestinationlist}
            />
            <span className="text-white" style={{ display: error.destination === "" ? "none" : "" }}>{t(error.destination)}</span>
          </div>
          <div
            className={
              props?.waytype?.id === 1 || props?.waytype?.id === 3
                ? "col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-5 locatin-input"
                : "col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-5 locatin-input"
            }
          >
            <div className="user-location datetime">
              <InputGroup>
                <InputGroup.Text>
                  <img src={pickup_time} alt="pickup time"></img>
                </InputGroup.Text>
                <DatePicker
                  locale={props?.language.toLowerCase()}
                  selected={typeof startDate === "undefined" ? new Date() : startDate}
                  showTimeSelect
                  onChange={(date) => dateTimechange(date)}
                  dateFormat="dd-MM-yyyy hh:mm aa"
                  timeFormat="hh:mm a"
                  minTime={mintime}
                  maxTime={maxtime}
                  minDate={new Date()}
                  timeIntervals={1}
                />
              </InputGroup>
            </div>
            <span className="text-white" style={{ display: error.pickupTime === "" ? "none" : "" }}>{t(error.pickupTime)}</span>
          </div>
          <div
            style={{
              display:
                props?.waytype?.id === 1 || props?.waytype?.id === 3
                  ? "none"
                  : "",
            }}
            className="col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-5 locatin-input"
          >
            <div className="user-location datetime">
              <InputGroup>
                <InputGroup.Text>
                  <img src={pickup_time} alt="pickup time"></img>
                </InputGroup.Text>
                <DatePicker
                  selected={typeof returnDate === "undefined" ? new Date() : returnDate}
                  showTimeSelect
                  locale={props?.language.toLowerCase()}
                  onChange={(date) => returnDatechange(date)}
                  dateFormat="dd-MM-yyyy hh:mm aa"
                  timeFormat="hh:mm a"
                  
                  minTime={mintime}
                  maxTime={maxtime}
                  minDate={typeof startDate === "undefined" ? new Date() : startDate}
                  timeIntervals={1}
                />
              </InputGroup>
            </div>
            <span className="text-white" style={{ display: error.returnDate === "" ? "none" : "" }}>{t(error.returnDate)}</span>
          </div>
        </Row>
        <div className="explore">
          <ButtonPage Text={t("pages.Explore Cabs")} onClick={(e) => exploreCab(e)} className={`button-submit explore-cab-btn`} type={"submit"} />
        </div>
      </div>
    </>
  );
}
ExplorecabPage.propTypes = {
  callBackList: PropTypes.func
}
ExplorecabPage.defaultProps = {
  callBackList: ()=>{}
}
const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  pickup: state?.home?.pickup,
  destination: state?.home?.destination,
  waytype: state?.home?.waytype,
  pickupdate_time: state?.home?.pickupdate_time,
  returndate_time: state?.home?.returndate_time,
  currentLocation: state?.home?.currentLocation,
  language: state?.languageState?.language,
  showmodify: state?.home?.showmodify,
  airport_list: state?.languageState?.airport_list,
});

export default connect(mapStateToProps, {
  maintainPickup,
  maintainDestination,
  maintainVehiclelist,
  maintainPickupdatetime,
  maintainReturndatetime,
  maintainWaytype,
  maintainModify,
  maintainAirportlist,
})(ExplorecabPage);
